// Aerator Project - Materials Specifications Seed Data
// Compatible with DFR-App-Demo

export const materialsSeedData = [
    {
        id: 'MAT-ABS-001',
        materialName: 'ABS High-Impact Resin',
        grade: 'HI-95',
        standard: 'ASTM D4673',
        properties: {
            'Tensile Strength': '48 MPa',
            'Impact Strength': '350 J/m (Izod notched)',
            'Flexural Modulus': '2300 MPa',
            'Heat Deflection Temp': '98°C @ 0.45 MPa',
            'Density': '1.05 g/cm³',
            'Mold Shrinkage': '0.4-0.7%'
        },
        linkedBomIds: [2, 9],
        supplier: 'PlasticTech Inc',
        certificationRequired: true,
        validationStatus: 'validated',
        generation: 0,
        cost: { value: 2.80, currency: 'USD/kg' },
        leadTimeWeeks: 2,
        testDataIds: ['TEST-DROP-001', 'TEST-THERMAL-001']
    },
    {
        id: 'MAT-SS304-001',
        materialName: '304 Stainless Steel',
        grade: '304',
        standard: 'ASTM A240',
        properties: {
            'Tensile Strength': '515 MPa',
            'Yield Strength': '205 MPa',
            'Elongation': '40%',
            'Hardness': '70 HRB',
            'Density': '8.0 g/cm³',
            'Corrosion Resistance': 'Excellent',
            'Food Safe': 'FDA Compliant'
        },
        linkedBomIds: [13, 14],
        supplier: 'PrecisionParts Co',
        certificationRequired: true,
        validationStatus: 'validated',
        generation: 0,
        cost: { value: 4.50, currency: 'USD/kg' },
        leadTimeWeeks: 3,
        testDataIds: ['TEST-CORROSION-001', 'TEST-SHAFT-STRENGTH-001']
    },
    {
        id: 'MAT-VITON-001',
        materialName: 'Viton FKM Fluoroelastomer',
        grade: 'A-Type',
        standard: 'ASTM D1418',
        properties: {
            'Hardness': '75 Shore A',
            'Tensile Strength': '10.5 MPa',
            'Elongation': '200%',
            'Compression Set': '25% @ 70h, 200°C',
            'Temp Range': '-20°C to 200°C',
            'Chemical Resistance': 'Excellent (oils, fuels)',
            'Food Safe': 'FDA CFR 177.2600 approved'
        },
        linkedBomIds: [16],
        supplier: 'AdvancedSeals Inc',
        certificationRequired: true,
        validationStatus: 'validated',
        generation: 1,
        cost: { value: 18.50, currency: 'USD/kg' },
        leadTimeWeeks: 4,
        testDataIds: ['TEST-SEAL-HOT-001', 'TEST-SEAL-LIFE-001'],
        testsCompleted: ['Hot liquid immersion', 'Compression set', 'Seal leak test'],
        testsRequired: ['Long-term aging', 'Chemical compatibility']
    },
    {
        id: 'MAT-NBR-001',
        materialName: 'NBR Nitrile Rubber',
        grade: 'N70',
        standard: 'ASTM D2000',
        properties: {
            'Hardness': '70 Shore A',
            'Tensile Strength': '14 MPa',
            'Elongation': '300%',
            'Compression Set': '20% @ 70h, 100°C',
            'Temp Range': '-40°C to 120°C',
            'Oil Resistance': 'Excellent',
            'Water Resistance': 'Good'
        },
        linkedBomIds: [17],
        supplier: 'AdvancedSeals Inc',
        certificationRequired: false,
        validationStatus: 'validated',
        generation: 0,
        cost: { value: 6.20, currency: 'USD/kg' },
        leadTimeWeeks: 2,
        testDataIds: ['TEST-SEAL-LIFE-001']
    },
    {
        id: 'MAT-TPE-001',
        materialName: 'TPE Thermoplastic Elastomer',
        grade: 'TPE-S65A',
        standard: 'ISO 18064',
        properties: {
            'Hardness': '65 Shore A',
            'Tensile Strength': '8 MPa',
            'Elongation': '450%',
            'Compression Set': '15% @ 22h, 70°C',
            'Temp Range': '-40°C to 100°C',
            'Overmolding': 'Compatible with ABS',
            'Recyclable': 'Yes'
        },
        linkedBomIds: [10],
        supplier: 'SealMaster Inc',
        certificationRequired: false,
        validationStatus: 'validated',
        generation: 1,
        cost: { value: 4.80, currency: 'USD/kg' },
        leadTimeWeeks: 2,
        testDataIds: ['TEST-IPX4-001', 'TEST-GASKET-001'],
        testsCompleted: ['IPX4 splash test', 'Compression set', 'Adhesion to ABS'],
        testsRequired: []
    },
    {
        id: 'MAT-CERAMIC-001',
        materialName: 'Silicon Nitride Ceramic',
        grade: 'Si3N4-Grade2',
        standard: 'ISO 26602',
        properties: {
            'Density': '3.2 g/cm³',
            'Hardness': '1600 HV',
            'Fracture Toughness': '6.5 MPa·m^0.5',
            'Thermal Expansion': '3.2 × 10^-6 /°C',
            'Max Operating Temp': '1200°C',
            'Friction Coefficient': '0.15 (dry)',
            'Noise Level': 'Ultra-quiet'
        },
        linkedBomIds: [7],
        supplier: 'TurboMotors Ltd (integrated)',
        certificationRequired: false,
        validationStatus: 'validated',
        generation: 2,
        cost: { value: 85.00, currency: 'USD/kg' },
        leadTimeWeeks: 6,
        testDataIds: ['TEST-BEARING-001', 'TEST-MOTOR-NOISE-001'],
        testsCompleted: ['Life cycle test', 'Noise measurement', 'Thermal cycling'],
        testsRequired: []
    },
    {
        id: 'MAT-STEEL-SPRING-001',
        materialName: 'Spring Steel - Nickel Plated',
        grade: 'AISI 1075',
        standard: 'ASTM A228',
        properties: {
            'Tensile Strength': '1930 MPa',
            'Yield Strength': '1655 MPa',
            'Hardness': '45-50 HRC',
            'Elastic Modulus': '207 GPa',
            'Fatigue Strength': '±550 MPa @ 10^7 cycles',
            'Plating': 'Nickel 5-10 μm',
            'Corrosion Resistance': 'Good'
        },
        linkedBomIds: [4],
        supplier: 'SpringTech Co',
        certificationRequired: false,
        validationStatus: 'validated',
        generation: 0,
        cost: { value: 12.50, currency: 'USD/kg' },
        leadTimeWeeks: 3,
        testDataIds: ['TEST-CONTACT-001', 'TEST-CORROSION-001']
    },
    {
        id: 'MAT-STEEL-NI-001',
        materialName: 'Nickel-Plated Steel Sheet',
        grade: 'SPCC + Ni',
        standard: 'JIS G3141',
        properties: {
            'Tensile Strength': '270-410 MPa',
            'Yield Strength': '140 MPa min',
            'Elongation': '30% min',
            'Thickness': '0.3-1.0 mm',
            'Plating Thickness': '3-8 μm nickel',
            'Surface Roughness': 'Ra 0.5 μm',
            'Conductivity': 'High (plated surface)'
        },
        linkedBomIds: [5],
        supplier: 'SpringTech Co',
        certificationRequired: false,
        validationStatus: 'validated',
        generation: 0,
        cost: { value: 8.30, currency: 'USD/kg' },
        leadTimeWeeks: 2,
        testDataIds: ['TEST-CONTACT-001']
    }
];

// Material Validation Matrix
export const materialValidationMatrix = {
    'MAT-ABS-001': {
        requiredTests: ['Drop test', 'Thermal cycling', 'UV exposure'],
        completedTests: ['Drop test', 'Thermal cycling'],
        pendingTests: ['UV exposure'],
        validationLevel: 'Production Ready'
    },
    'MAT-SS304-001': {
        requiredTests: ['Corrosion test', 'Tensile test', 'Food safety cert'],
        completedTests: ['Corrosion test', 'Tensile test', 'Food safety cert'],
        pendingTests: [],
        validationLevel: 'Fully Validated'
    },
    'MAT-VITON-001': {
        requiredTests: ['Hot liquid immersion', 'Compression set', 'FDA food contact'],
        completedTests: ['Hot liquid immersion', 'Compression set', 'FDA food contact'],
        pendingTests: [],
        validationLevel: 'Fully Validated'
    },
    'MAT-NBR-001': {
        requiredTests: ['Seal life test', 'Compression set'],
        completedTests: ['Seal life test', 'Compression set'],
        pendingTests: [],
        validationLevel: 'Fully Validated'
    },
    'MAT-TPE-001': {
        requiredTests: ['IPX4 test', 'Adhesion test', 'Compression set'],
        completedTests: ['IPX4 test', 'Adhesion test', 'Compression set'],
        pendingTests: [],
        validationLevel: 'Fully Validated'
    },
    'MAT-CERAMIC-001': {
        requiredTests: ['Life cycle', 'Noise measurement', 'Thermal shock'],
        completedTests: ['Life cycle', 'Noise measurement', 'Thermal shock'],
        pendingTests: [],
        validationLevel: 'Fully Validated'
    },
    'MAT-STEEL-SPRING-001': {
        requiredTests: ['Fatigue test', 'Corrosion test'],
        completedTests: ['Fatigue test', 'Corrosion test'],
        pendingTests: [],
        validationLevel: 'Fully Validated'
    },
    'MAT-STEEL-NI-001': {
        requiredTests: ['Contact resistance', 'Corrosion test'],
        completedTests: ['Contact resistance', 'Corrosion test'],
        pendingTests: [],
        validationLevel: 'Fully Validated'
    }
};

// Material Upgrade Path (Evolution)
export const materialEvolution = [
    {
        component: 'Shaft Seal',
        iteration: 1,
        material: 'Silicone O-ring',
        rpnContribution: 270,
        issue: 'Failed hot liquid test at 80°C'
    },
    {
        component: 'Shaft Seal',
        iteration: 8,
        material: 'Viton FKM O-ring',
        rpnContribution: 162,
        improvement: 'Passed hot liquid, but single point of failure'
    },
    {
        component: 'Shaft Seal',
        iteration: 17,
        material: 'Viton FKM + NBR dual seal',
        rpnContribution: 108,
        improvement: 'Redundant design, 60% RPN reduction'
    },
    {
        component: 'Motor Bearing',
        iteration: 1,
        material: 'Steel ball bearing',
        rpnContribution: 64,
        issue: 'Noisy operation complaints'
    },
    {
        component: 'Motor Bearing',
        iteration: 12,
        material: 'Ceramic ball bearing',
        rpnContribution: 64,
        improvement: '40% noise reduction, same RPN'
    }
];

export const materialsSeedDataInfo = {
    totalMaterials: materialsSeedData.length,
    validatedMaterials: materialsSeedData.filter(m => m.validationStatus === 'validated').length,
    avgCostPerKg: (materialsSeedData.reduce((sum, m) => sum + (m.cost?.value || 0), 0) / materialsSeedData.length).toFixed(2),
    criticalMaterials: ['MAT-SS304-001', 'MAT-VITON-001', 'MAT-ABS-001'],
    generatedDate: '2025-12-12',
    projectIteration: 17,
    totalEvolutionSteps: materialEvolution.length
};
